<template>
    <div class="cambro-app" @click="navigateToCambroApp">
      <img src="images/cambro-app.jpg" width="100%"/>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Mobile',
    methods: {
      navigateToCambroApp() {
        window.location.href = 'https://apps.apple.com/us/app/cambro/id964699238';
      }
    }
  }
  </script>
  